import { MIMETYPE_GPX } from '@disy/lib/media-type';

import { AbstractDataViewExportAction } from 'cadenza/actions/table/abstract-data-view-export-action';
import type { ExportActionContext } from 'cadenza/workbook/actions/export-actions';
import type { DataViewId } from 'cadenza/workbook/model/data-view-id.gen';
import { isMapFullscreenSidebarModalOpen } from 'cadenza/workbook/ui/map-fullscreen-sidebar-modal/map-fullscreen-sidebar-modal-utils';

import i18n from './export-gpx-action.properties';

export class ExportGpxAction extends AbstractDataViewExportAction {
  readonly #enabled;
  readonly #dataViewId;
  readonly #actionContext;

  constructor(dataViewId: DataViewId, actionContext: ExportActionContext, enabled: boolean = true) {
    super(dataViewId, actionContext, MIMETYPE_GPX, {
      label: i18n('action.label'),
      dialogTitle: i18n('dialog.title'),
      tooltip: enabled ? '' : i18n('action.tooltip.disabled'),
    });
    this.#enabled = enabled;
    this.#dataViewId = dataViewId;
    this.#actionContext = actionContext;
  }

  override async execute() {
    const { GpxExportDialog } = await import('cadenza/gpx-export-dialog/gpx-export-dialog');
    const dialog = new GpxExportDialog(i18n('dialog.title'), this.#dataViewId, this.#actionContext);
    dialog.connectAndShow({ hidePreviousModals: !isMapFullscreenSidebarModalOpen() });
  }

  // enabledSync is here currently not called, so we have to override also the deprecated method "disabled"
  override get disabled() {
    return !this.#enabled;
  }
}
